<div [attr.id]="key" [ngClass]="class" [attr.data-cy]="class + '_chart'" class="chart-area chart_height_xxs"
    width="100%" [style.height]="height+ 'px'">
</div>